export const logoutUser = () => {
  // Remove dados do usuário do localStorage
  localStorage.removeItem('userDataLogin');
  localStorage.removeItem('TOKEN');
  
  // Redireciona para a página inicial (onde está o login)
  window.location.href = '/account';
};
